import React from 'react';

const Tooltip = (props) => {
    const {
        leftContent,
        rightContent,
    } = props;
    return (
        <div className="filter-tooltip">
            <button className="icon-tooltip filter-tooltip-trigger" onClick={(e) => toggleTooltip(e)} aria-label="Tooltip Trigger"></button>
            <div className="filter-tooltip__wrapper">
                <button className="icon-close filter-tooltip-close" onClick={(e) => toggleTooltip(e)}></button>
                <div className="filter-tooltip__container">
                    <div className="filter-tooltip__content filter-tooltip__content--left" dangerouslySetInnerHTML={{ __html: leftContent }} />
                    <div className="filter-tooltip__content filter-tooltip__content--right" dangerouslySetInnerHTML={{ __html: rightContent }} />
                </div>
            </div>
        </div>
    )

    function toggleTooltip(e) {
        e.preventDefault();
        const tooltipWrapper = e.target.closest('.filter-tooltip');

        if (tooltipWrapper.classList.contains('filter-tooltip--active')) {
            tooltipWrapper.classList.remove('filter-tooltip--active');
        } else {
            Array.from(document.querySelectorAll('.filter-tooltip')).forEach((el) => el.classList.remove('filter-tooltip--active'));
            tooltipWrapper.classList.add('filter-tooltip--active');
        }
    }
}

export default Tooltip;